module.exports = __webpack_public_path__ + "img/old-typical-phone.0f155871.svg";